// コメント添付ファイルの上限。storage.rules の isAllowedUpload() はこの定義から scripts/syncStorageRules.js で生成する
// - サイズ: 大量・巨大ファイルのアップロードによるコスト増を防ぐため。通常の帳票・証憑が収まる 20MB とする
// - 種別: 業務で添付される画像・PDF・Office・CSV・テキスト・ZIP に限定する。
//   SVG / HTML 等はダウンロード URL を開いた際にスクリプトが実行され得るため許可しない
// パターンは storage.rules の文字列リテラルに埋め込むため、シングルクォートとバックスラッシュを使わない (ドットは [.] で表す)
const commentFileMaxSize = 20 * 1024 * 1024;
const commentFileContentTypePatterns = [
  'image/(png|jpeg|gif|webp|heic|heif|bmp|tiff)',
  'application/pdf',
  'text/(plain|csv)',
  'application/(msword|vnd[.]ms-excel|vnd[.]ms-powerpoint)',
  'application/vnd[.]openxmlformats-officedocument[.][a-z.]+',
  'application/(zip|x-zip-compressed)',
];
const commentFileContentTypePattern = `(${commentFileContentTypePatterns.join('|')})`;

// storage.rules の matches() は文字列全体との一致なので、JS 側も ^ と $ で囲んで同じ判定にする
const commentFileContentTypeRegExp = new RegExp(`^${commentFileContentTypePattern}$`);
const isAllowedCommentFile = (file) => file.size <= commentFileMaxSize && commentFileContentTypeRegExp.test(file.type);

module.exports = {
  commentFileMaxSize,
  commentFileContentTypePattern,
  isAllowedCommentFile,
};
